import { sensothingRynanApi } from './globalAxios';
import config from 'src/config';

// Auth
export const rynanLogin = () =>
  sensothingRynanApi.post('/auth', {
    user_name: config.RYNAN_USERNAME,
    password: config.RYNAN_PASSWORD,
  });

// Get station list (sử dụng token)
export const getRynanStationList = (token: string) =>
  sensothingRynanApi.get('/get-list-stations', {
    headers: { 'x-access-token': token }
  });

// Get station data by serial (sử dụng token)
export const getRynanObservation = (
  token: string,
  serialStation: string,
  startDate: string,
  endDate: string,
  limit: number
) =>
  sensothingRynanApi.get(
    `/get-data-stations?so_serial=${serialStation}&tu_ngay=${startDate}&den_ngay=${endDate}&limit=${limit}`,
    {
      headers: {
        'x-access-token': token,
        'x-api-key': config.RYNAN_X_API_KEY
      }
    }
  );
